export default __webpack_public_path__ + "static/property-img-3_1400-cb3a6fc54b30962f614ad942ecbbab9d.jpg";